import { useSelector } from "react-redux";
import { useEffect, Suspense } from "react";
import { Route, Redirect } from "react-router-dom";
import SbLoading from "../../components/common/SbLoading";
import { checkCashierAuthOnHome } from "../../utils/constants/checkCashierAuth";

const CashierPublicRoute = ({ component: Component, ...rest }) => {
  const isCashierAuthenticated = useSelector(
    (state) => state.cashierRoot.isAuthenticated
  );

  useEffect(() => {
    checkCashierAuthOnHome();
  }, []);

  return (
    <Route
      {...rest}
      render={(props) =>
        !isCashierAuthenticated ? (
          <Suspense fallback={<SbLoading fullPage={true} />}>
            <Component {...props} />
          </Suspense>
        ) : (
          localStorage.storeId && (
            <Redirect to={`/cashier-home/${localStorage.storeId}`} />
          )
        )
      }
    />
  );
};

export default CashierPublicRoute;
